export function isBasicLinkedinSearch(url: string): boolean {
  return url && url.includes('linkedin.com/search/results/');
}
